import React from 'react';
import styles from '../styles/PWAInstallPrompt.module.css';

function PWAInstallPrompt({ onInstall, onDismiss, isIOS }) {
  if (isIOS) {
    return (
      <div className={styles.banner}>
        <div className={styles.content}>
          <div className={styles.icon}>📱</div>
          <div className={styles.text}>
            <div className={styles.title}>Keep Sophia Close</div>
            <div className={styles.description}>
              Tap <span className={styles.shareIcon}>⎙</span> then "Add to Home Screen"
            </div>
          </div>
          <button className={styles.dismissButton} onClick={onDismiss}>
            ✕
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.banner}>
      <div className={styles.content}>
        <div className={styles.icon}>📱</div>
        <div className={styles.text}>
          <div className={styles.title}>Keep Sophia Close</div>
          <div className={styles.description}>
            Quick check-ins and gentle nudges when you need them
          </div>
        </div>
        <div className={styles.actions}>
          <button className={styles.installButton} onClick={onInstall}>
            Install
          </button>
          <button className={styles.dismissButton} onClick={onDismiss}>
            ✕
          </button>
        </div>
      </div>
    </div>
  );
}

export default PWAInstallPrompt;
